module.exports = __webpack_public_path__ + "static/123-02-02-85dbb408c09ac5c75728b69bf6d5adf6.png";